import { RichTextInput, ListButtons, FormatButtons } from 'ra-input-rich-text';
import PropTypes from 'prop-types';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

export const CustomRichText = ({ source, label, fullWidth, hasImages = false, ...props }) => {
    return (
        <RichTextInput
            source={source}
            label={label}
            fullWidth={fullWidth}
            toolbar={[<FormatButtons key='format' />, <ListButtons key='list' />]}
            className='rich-text-input'
            sx={{
                position: 'relative',
                zIndex: 1,
                margin: '0',
                '& .MuiStack-root': {
                    margin: '0 !important',
                },
                '& .RaLabeled-label': {
                    display: 'none',
                },
                '& .MuiToggleButtonGroup-root': {
                    position: 'relative',
                    display: 'inline-block',
                    verticalAlign: 'top',
                    '& .MuiToggleButton-root': {
                        padding: '6px',
                        border: 'none',
                        borderRadius: '10px',
                        backgroundColor: Palette.gray.gray150,
                        '& .MuiSvgIcon-root': {
                            width: '24px',
                            height: '24px',
                        },
                    },
                    '& .MuiToggleButton-root + .MuiToggleButton-root': {
                        marginLeft: '8px',
                    },
                },
                '& .RaRichTextInput-editorContent': {
                    width: 'auto',
                    position: 'relative',
                    zIndex: 1,
                    '& .tiptap': {
                        borderRadius: '20px',
                        border: `2px solid ${Palette.gray.gray100}`,
                        backgroundColor: Palette.white,
                        minHeight: '200px',
                        maxWidth: '100%',
                        padding: hasImages ? '24px 24px 175px' : '24px 24px 70px',
                        fontSize: '14px',
                        fontFamily: 'Inter, Arial, sans-serif',
                        [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                            paddingBottom: hasImages ? '220px' : '110px',
                            minHeight: '250px',
                        },
                        [`@media (max-width: ${breakpoints.values.lg}px)`]: {
                            maxWidth: '100%',
                        },
                        '&:focus': {
                            outline: `2px solid ${Palette.black}`,
                            outlineOffset: '-2px',
                            boxShadow: `0 0 0 2px ${Palette.yellow.yellow200}`,
                        },
                        '&:hover': {
                            backgroundColor: Palette.white,
                        },
                    },
                    '& .ProseMirror:focus': {
                        backgroundColor: Palette.white,
                    },
                },
                '& .MuiToggleButtonGroup-root:nth-of-type(1)': {
                    position: 'absolute',
                    bottom: 24,
                    left: 24,
                    zIndex: 2,
                    [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                        bottom: 70,
                    },
                },
                '& .MuiToggleButtonGroup-root:nth-of-type(2)': {
                    position: 'absolute',
                    bottom: 24,
                    left: 244,
                    zIndex: 2,
                    [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                        bottom: 24,
                        left: 24,
                    },
                },
                '& .MuiToggleButtonGroup-grouped.Mui-selected': {
                    outline: `2px solid ${Palette.black}`,
                    outlineOffset: '-2px',
                },
                '& .MuiToggleButtonGroup-grouped.Mui-selected + .MuiToggleButtonGroup-grouped.Mui-selected': {
                    marginLeft: '8px !important',
                },
            }}
            {...props}
        />
    );
};

CustomRichText.propTypes = {
    source: PropTypes.string,
    label: PropTypes.string,
    fullWidth: PropTypes.bool,
    hasImages: PropTypes.bool,
};
